import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit {
  private timeout: number = null;
  private static readonly DEFAULT_TITLE: string = "Search"
  private static readonly DEFAULT_PLACEHOLDER: string = "Type to search...";

  @ViewChild('input', {static: true}) input: ElementRef;

  @Input() public title: string = SearchBarComponent.DEFAULT_TITLE;
  @Input() public placeholder: string = SearchBarComponent.DEFAULT_PLACEHOLDER;
  @Output() public onSearchTextChanged: EventEmitter<string> = new EventEmitter<string>();

  @Input() @Output() public searchText: string = "";
  public isFocused: boolean = false;

  constructor( private translate: TranslateService,) {
    this.title = this.translate.instant("General.Search");
    this.placeholder = this.translate.instant("General.SearchInfo");
   }

  public ngOnInit(): void { }

  public onKeySearch(event: any) {
    window.clearTimeout(this.timeout);
    this.timeout = window.setTimeout(() => {
      this.onSearchTextChanged.emit(this.searchText);
    }, 500);
  }

  public async onFocus(): Promise<void> {
    if (this.isFocused) {
      await new Promise(f => setTimeout(f, 100));
    }
    this.isFocused = !this.isFocused;
  }

  public emptyValue(): void{
    this.searchText = "";
    this.onKeySearch(null);
  }
}
